const createBlockMarker = ({
	OverlayView = google.maps.OverlayView,
	...args
}) => {

	class BlockMarker extends OverlayView {
		constructor() {
			super();
			this.latlng = args.latlng;
			this.html = args.html;
			this.conflictCount = args.conflictCount;
			this.overlapCount = args.overlapCount;
			this.requestId = args.requestId;
			this.blockId = args.blockId;
			this.id = null;
			this.setMap(args.map);
		}

		createDiv() {
			var self = this;

			if (this.id != null) {
				// remove the old one...
				document.getElementById(this.id).remove();
			}

			this.div = document.createElement('button');
			this.div.style.position = 'absolute';
			this.div.type = 'button';
			this.id = "block-marker-" + (Math.random() * 10000000);

			if (this.conflictCount > 0) {
				this.div.className = 'block-marker-wrapper has-conflicts';
			} else {
				this.div.className = 'block-marker-wrapper';
			}
			let html = "";
			if (this.conflictCount > 0) {
				html += "<span class='icon-alert-circle'></span>";
			} else {
				// if (this.overlapCount > 0) {
				html += "<span class='block-marker---overlap-count'>" + this.overlapCount + "</span>";
				// }
			}
			this.div.innerHTML = html;

			google.maps.event.addDomListener(this.div, 'click', function(event) {
				// stop click reaction on another layers
				event.stopPropagation();
				// add also event to 3rd parameter for catching
				google.maps.event.trigger(self, 'click', event);
			});
		}

		appendDivToOverlay() {
			const panes = this.getPanes();
			panes.overlayMouseTarget.appendChild(this.div);
		}

		positionDiv() {
			const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
			if (point) {
				this.div.style.left = `${point.x}px`;
				this.div.style.top = `${point.y}px`;
			}
		}

		draw() {
			if (!this.div) {
				this.createDiv();
				this.appendDivToOverlay();
			}
			this.positionDiv();
		}

		remove() {
			if (this.div) {
				this.setMap(null);
				this.div.parentNode.removeChild(this.div);
				this.div = null;
			}
		}

		getId() {
			return this.id;
		}

		getPosition() {
			return this.latlng;
		}

		getDraggable() {
			return false;
		}
	}

	return new BlockMarker();
};

export default createBlockMarker;